export default function TargetLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="17.911 17.911 724.528 724.528"
      id="target"
    >
      <path
        fill="#fff"
        d="M724.946 378.412c0 187.178-155.587 339.09-347.293 339.09S30.359 565.59 30.359 378.412c0-187.177 155.588-339.089 347.294-339.089s347.293 151.912 347.293 339.089z"
      ></path>
      <path
        fill="#c00"
        d="M380.176 17.911c-200.098 0-362.265 162.188-362.265 362.264 0 200.084 162.166 362.265 362.265 362.265 200.098 0 362.264-162.181 362.264-362.265-.001-200.076-162.167-362.264-362.264-362.264zm0 120.755c133.398 0 241.509 108.14 241.51 241.509 0 133.37-108.111 241.51-241.51 241.51s-241.51-108.14-241.51-241.51 108.11-241.509 241.51-241.509zm0 120.754c-66.7 0-120.755 54.07-120.755 120.754 0 66.692 54.056 120.755 120.755 120.755S500.93 446.867 500.93 380.175c-.001-66.685-54.055-120.755-120.754-120.755zM678.51 657.2c-11.578 0-21.31 9.106-21.31 21.311 0 12.338 9.731 21.31 21.31 21.31 11.437 0 21.31-8.972 21.31-21.31 0-12.204-9.873-21.311-21.31-21.311zm0 3.552c9.519 0 17.048 7.657 17.048 17.759 0 10.257-7.529 17.758-17.048 17.758-9.66 0-17.048-7.501-17.048-17.758.001-10.102 7.388-17.759 17.048-17.759zm-8.168 5.505v24.507h3.729v-10.655h4.262l6.394 10.655h4.084l-6.926-10.833c3.48-.482 6.393-2.351 6.393-6.748 0-4.873-2.841-6.926-8.523-6.926h-9.413zm3.729 3.197h4.972c2.558 0 5.328.511 5.328 3.551 0 3.772-2.734 3.907-5.86 3.907h-4.439v-7.458z"
      ></path>
    </svg>
  );
}
